(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sp-header"]) return;
  try {
    
(() => {
  const closeDropdowns = (except) => {
    document.querySelectorAll('.sp-nav-dropdown[open]').forEach(item => {
      if (item !== except) item.open = false;
    });
  };
  document.addEventListener('click', event => {
    const dropdown = event.target.closest('.sp-nav-dropdown');
    closeDropdowns(dropdown);
    if (event.target.closest('#mobile-nav a')) {
      const nav = document.getElementById('mobile-nav');
      const toggle = document.querySelector('.menu-toggle');
      if (nav) nav.hidden = true;
      toggle?.setAttribute('aria-expanded', 'false');
      closeDropdowns();
    }
    if (event.target.closest('.menu-toggle')) closeDropdowns();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dropdown = event.target.closest('.sp-nav-dropdown[open]');
    if (!dropdown) { closeDropdowns(); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    dropdown.open = false;
    dropdown.querySelector('summary')?.focus();
  }, true);
  document.addEventListener('focusin', event => {
    closeDropdowns(event.target.closest('.sp-nav-dropdown'));
  });
  window.matchMedia('(max-width: 1150px)').addEventListener('change', () => {
    closeDropdowns();
    const nav = document.getElementById('mobile-nav');
    if (nav) nav.hidden = true;
    document.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'false');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
